import { render, staticRenderFns } from "./HeadlineRelatedTitle.vue?vue&type=template&id=0a129af6"
import script from "./HeadlineRelatedTitle.vue?vue&type=script&lang=ts"
export * from "./HeadlineRelatedTitle.vue?vue&type=script&lang=ts"
import style0 from "./HeadlineRelatedTitle.vue?vue&type=style&index=0&id=0a129af6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports